import { Component } from '@angular/core';

@Component({
  selector: 'app-reserves',
  imports: [],
  templateUrl: './reserves.component.html',
  styleUrl: './reserves.component.scss'
})
export class ReservesComponent {

}
